import geohash from 'ngeohash';

/**
 * Normalize location to geohash for stable cache keys
 * @param lat Latitude
 * @param lng Longitude
 * @param precision Geohash precision (6 = ~1.2km, 5 = ~4.9km)
 * @returns Geohash string or undefined if lat/lng not provided
 */
export function normalizeLocationKey(
  lat?: number,
  lng?: number,
  precision = 6
): string | undefined {
  if (!lat || !lng) return undefined;
  return geohash.encode(lat, lng, precision);
}

/**
 * Create normalized query key for stores
 * Uses geohash precision 6 (~1.2km) for location-based caching
 */
export function createStoreQueryKey(params: {
  city_id?: string;
  lat?: number;
  lng?: number;
  [key: string]: any;
}) {
  const { lat, lng, ...rest } = params;
  return [
    'stores',
    {
      ...rest,
      geohash: normalizeLocationKey(lat, lng, 6), // ~1.2km precision
    },
  ];
}

/**
 * Create normalized query key for deals
 * Uses geohash precision 5 (~4.9km) for broader location-based caching
 */
export function createDealQueryKey(params: {
  city_id?: string;
  lat?: number;
  lng?: number;
  [key: string]: any;
}) {
  const { lat, lng, ...rest } = params;
  return [
    'deals',
    {
      ...rest,
      geohash: normalizeLocationKey(lat, lng, 5), // ~4.9km precision for deals
    },
  ];
}
